import { apiFetch, getAuthHeader, handleUnauthorized } from './core'

export interface TestdataGenerationSummary {
  id: number
  created_at: string
  created_by: string
  document_type: string
  document_number: string
  xml_format: string
  language: string | null
  supplier_name: string | null
  supplier_gln: string | null
  buyer_name: string | null
  buyer_gln: string | null
  line_count: number
  total_net_amount: number | null
  total_vat_amount: number | null
  total_amount: number | null
  has_pdf: boolean
}

export interface TestdataGenerationDetail extends TestdataGenerationSummary {
  input_params: Record<string, unknown> | null
}

export async function getTestdataHistory(): Promise<TestdataGenerationSummary[]> {
  return apiFetch<TestdataGenerationSummary[]>('/api/testdata/history')
}

export async function getTestdataGeneration(id: number): Promise<TestdataGenerationDetail> {
  return apiFetch<TestdataGenerationDetail>(`/api/testdata/history/${id}`)
}

export async function deleteTestdataGeneration(id: number): Promise<void> {
  await apiFetch(`/api/testdata/history/${id}`, { method: 'DELETE' })
}

async function _downloadFile(url: string, filename: string): Promise<void> {
  const res = await fetch(url, { headers: { Authorization: getAuthHeader() } })
  handleUnauthorized(res)
  if (!res.ok) throw new Error(`Download mislukt (${res.status})`)
  const blob = await res.blob()
  const objectUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = objectUrl
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(objectUrl)
}

export async function downloadTestdataXml(id: number, docNumber: string, docType: string): Promise<void> {
  const safe = docNumber.replace(/[/\\]/g, '-')
  await _downloadFile(`/api/testdata/history/${id}/xml`, `${safe}_${docType}.xml`)
}

export async function downloadTestdataPdf(id: number, docNumber: string, docType: string): Promise<void> {
  const safe = docNumber.replace(/[/\\]/g, '-')
  await _downloadFile(`/api/testdata/history/${id}/pdf`, `${safe}_${docType}.pdf`)
}
